module.exports = __webpack_public_path__ + "img/logo.90118425.svg";